function pxToRem(number: any, baseNumber = 16) {
    return `${number / baseNumber}rem`;
}

export default pxToRem;
